import React, { Component } from 'react';
// import { Link } from 'react-router-dom';

export default class DeleteButton extends Component {
  constructor(props) {
    super(props);

    const { label, route, id, small } = this.props;

    this.state = {
      text: label,
      classes: 'btn-warning',
      count: 0,
      label,
      route,
      id,
      small
    }

    this.handleClick = this.handleClick.bind(this);
  }

  reset() {
    this.setState({
      count: 0,
      text: this.state.label,
      classes: 'btn-warning'
    });
  }

  handleClick(){
    const { label, route, id, text } = this.state;

    this.setState(previousValue => ({
      count: previousValue.count + 1,
    }));

    if(this.state.count === 0) {
      this.setState({
        text: "Are you sure?",
        classes: 'btn-danger'
      });
    }
    else if(this.state.count === 1) {
      this.setState({
        text: "deleting..."
      });
      // if(!this.route){
      //   setTimeout(()=>{
      //     this.reset();
      //   }, 1000);
      // }
      // else{

        const headers = {
          'X-CSRF-TOKEN': window.Laravel.csrfToken,
          'X-Requested-With': 'XMLHttpRequest'
        };

        axios
        .delete(`/api/${route}/${id}`, headers)
        .then(response => {
          this.reset();
          this.props.redirect();
        })
        .catch(err => {
          console.log(err.response);

        });

      // }


    }
    else {
      this.reset();
    }

  }


  render(){

    const { label, route, id, text, classes, small } = this.state;

    let sizeClass = 'mtb10';

    if(small){
      sizeClass = 'btn-sm';
    }

    return (
      <button onClick={this.handleClick} className={`btn pull-right ${sizeClass} ${classes}`}>{text}</button>
    );
  }

}
